export const colors = {
  verseBlue: '#0085FF',
  black: '#0A0A2C',
  verseGray: '#424242',
  white: '#FFFFFF',
};
